module.exports = __webpack_public_path__ + "img/sidebar-1.a47cda28.png";